@if (currentAction === 'transfert') {
  <p-dialog
    [contentStyle]="{ overflow: 'auto', 'max-width': '75vw', 'height': '80vh'}"
    [styleClass]="'sm:col-12 md:col-12 lg:col-7 xl:col-6'"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    (onHide)="close('move')"
    >
    <ng-template pTemplate="header">
      <span class="p-dialog-title">
        {{'Trs_Bsk' | translate}}
      </span>
    </ng-template>
    <div class="grid col-12" [ngClass]="{'h-full': actionGroup === false}">
      <div class="col-12">
        @if (bskMode === true) {
            {{'Ori' | translate}}  {{ currentSelectedBsk.bskLabel }} ,{{'Dest' | translate}} : {{ currentTransfertBsk.bskLabel }}
        }@else {
            {{'Dest' | translate}}  {{ currentTransfertBsk.bskLabel }}
        }
      </div>
    <div class="col-12 md:col-12 align-right">
        <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="switchTransfert()" label="{{'Cancel' | translate}}"></button>
        @if (sendToBsk === false) {
            @if (
                (currentTransfertBsk.bskAllowActions === 'CopyMove' ||
                    currentTransfertBsk.bskAllowActions === 'Move') &&
                bskMode === true && currentTransfertBsk.bskDuplicateDocument === false
                    ) {
                <button
                        type="button"
                        pButton
                        class="margin"
                        (click)="onApplyTrans('move')"
                        label="{{'Move_Doc' | translate}}"
                ></button>
            }
            @if (
                (currentTransfertBsk.bskAllowActions === 'CopyMove' ||
                    currentTransfertBsk.bskAllowActions === 'Copy') &&
                bskMode === true && currentTransfertBsk.bskDuplicateDocument === false
                    ) {
                <button
                        type="button"
                        pButton
                        class="margin"
                        (click)="onApplyTrans('copy')"
                        label="{{'Copy' | translate}}"
                ></button>
            }
            @if (
                currentTransfertBsk.bskDuplicateDocument === true &&
                bskMode === true
                    ) {
                <button
                        type="button"
                        pButton
                        class="margin"
                        (click)="onApplyTrans('duplicate')"
                        label="{{'Duplic' | translate}}"
                ></button>
            }
            @if (bskMode === false) {
                <button
                        type="button"
                        pButton
                        class="margin"
                        (click)="onApplyTrans('insert')"
                        label="{{'Send' | translate}}"
                ></button>
            }
        }
        @if (sendToBsk === true) {
            <button
                    type="button"
                    pButton
                    class="margin"
                    (click)="onApplyTrans('addbsk')"
                    label="{{'Atf_AddBsk' | translate}}"
            ></button>
        }
    </div>      
      @if (actionGroup === true) {
        @if (currentTransfertBsk.bskType === 'btMail') {
          <div class="col-12 nopad">
            <infosmail [visuMode]="false" [bskTypeMail]="true" [editMode]="true" [infosMailDisplay]="infosMail"></infosmail>
          </div>
        }
        @if (currentTransfertBsk.bskIndexInputMode !== noInputMod) {
          <span class="col-12">
            <div class="col-12">
              <p-checkbox
                name="ckActionGroup"
                [(ngModel)]="updateIndex"
                binary="true"
                inputId="ckActionGroup"
              ></p-checkbox>
              <label for="ckActionGroup" class="ml-2">{{'Update_Idx' | translate}}</label>
            </div>
            @if (updateIndex === true) {
              <div class="col-12">
                <inputvalue [title]="'Index_B' | translate" [dataVariableList]="variableListTransfert" [libAction]="false" [editorService]="editorService">
              </inputvalue>
            </div>
            }
          </span>
        }        
      }@else {
        <div class="grid col-12" style="height: 95%">
          <div class="col-6 md:col-6 lg:col-6">
            @if (currentTransfertBsk.bskIndexInputMode !== noInputMod) {
              @if (currentTransfertBsk.bskType === 'btMail') {
                <div class="col-12 nopad">
                  <infosmail [visuMode]="false" [bskTypeMail]="true" [editMode]="true" [infosMailDisplay]="infosMail"></infosmail>
                </div>
              }
              <span class="col-12">
                @if (bskMode === false) {
                  <div class="col-12">
                    <p-checkbox
                      name="ckActionGroup"
                      [(ngModel)]="updateIndex"
                      binary="true"
                      inputId="ckActionGroup"
                    ></p-checkbox>
                    <label for="ckActionGroup" class="ml-2">{{'Update_Idx' | translate}}</label>
                  </div>
                }
                @if (updateIndex === true) {
                  <div class="col-12">
                    <inputvalue [title]="'Index_B' | translate" [dataVariableList]="variableListTransfert" [libAction]="false" [editorService]="editorService">
                  </inputvalue>
                </div>
                }
              </span>
            }
          </div>
          <div class="col-6 md:col-6 lg:col-6">
              <atf-view
                [atfName]="currentAtf"
                [docId]="docIdList[0].doc_docid"
              >
              </atf-view>          
          </div>
        </div>
      }
  </div>
</p-dialog>
}

<app-item-confirm [key]="'transbsk'" [severity]="'alert'" (onAccept)="onApplyTrans($event)"></app-item-confirm>
